import React from 'react'

import MoreProject_Popover from "../../../../core/gd-ui/more/project/popover"
import ControlButtonStandard, {
    ControlButtonType
} from "../../../gd-components/buttons/control-button/control-button-standard";
import {ControlButtonSize} from "../../../gd-components/buttons/control-button/@types";
import {PopoverAttachmentType} from "../../../gd-components/gd-popover/@const";

type Props = {
    className?      : string
    style?          : any

    parent          : any
    projectId       : ID

    showPinStar?    : boolean
    isFloatingMore? : boolean
}

type State = {
    showPopover: boolean
}

export default class NavigationMenuItemProjectMore extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            showPopover: false
        }
    }

    showPopover = (e: React.MouseEvent) => {
        if (e) e.stopPropagation();
        if (!this.state.showPopover) this.setState({showPopover: true})

        // highlight menu
        if (!this.props.parent.state.hovered) this.props.parent.setState({hovered: true})
    }

    hidePopover = (e: React.MouseEvent) => {

        if (this.state.showPopover) this.setState({showPopover: false})

        // hide parent menu highlight
        if (this.props.parent.state.hovered) this.props.parent.setState({hovered: false})
    }

    render() {

        // const classes = Classes(this.props.className, {
        //     'more ui5-ico-more s20' : !this.props.isFloatingMore,
        //     'popover-shown'         : this.state.showPopover
        // });

        const classes = Classes("more", this.props.className, {
            'popover-shown'         : this.state.showPopover
        })

        const targetOffset = !this.props.isFloatingMore ? "0 20" : undefined

        const project = gd.session.projects.get(this.props.projectId)?.toModel();


        return (
            <ControlButtonStandard type={ControlButtonType.MORE} size={ControlButtonSize.SIZE_24} onClick={this.showPopover} className={classes}>
                {this.state.showPopover &&
                    <MoreProject_Popover hidePopover                = {this.hidePopover}
                                         attachment                 = "top left"
                                         targetAttachment           = "top right"
                                         targetOffset               = {targetOffset}
                                         attachmentType             = {PopoverAttachmentType.VERTICAL}
                                         showPinStar                = {this.props.showPinStar}
                                         // @ts-ignore
                                         project                    = {project}
                                         outsideClickIgnoreClass    = "color-with-icon"
                                         parent                     = {this} />}
            </ControlButtonStandard>
        )

        // return (
        //     <div className={classes} style={this.props.style} onClick={this.showPopover}>
        //         {this.state.showPopover &&
        //             <MoreProject_Popover hidePopover                = {this.hidePopover}
        //                                  attachment                 = "top left"
        //                                  targetAttachment           = "top right"
        //                                  targetOffset               = {targetOffset}
        //                                  attachmentType             = {PopoverAttachmentType.VERTICAL}
        //                                  showPinStar                = {this.props.showPinStar}
        //                                  // @ts-ignore
        //                                  project                    = {project}
        //                                  outsideClickIgnoreClass    = "color-with-icon"
        //                                  parent                     = {this} />}
        //     </div>
        // );
    }
}
